import type { ReactNode } from "react";

/** Keep service artwork visible and separate from readable, server-rendered copy. */
export function EditorialHero({
  image,
  children,
  alt = "",
}: {
  image?: string;
  children: ReactNode;
  alt?: string;
}) {
  return (
    <section className="bg-[#f5f3ef]">
      <div
        className={`mx-auto grid max-w-7xl items-center gap-10 px-6 py-12 sm:px-8 sm:py-20 lg:gap-16 ${image ? "lg:grid-cols-2" : ""}`}
      >
        <div className="min-w-0 text-start">{children}</div>
        {image && (
          <figure className="min-w-0">
            <img
              src={image}
              alt={alt}
              width={1200}
              height={800}
              fetchPriority="high"
              decoding="async"
              className="aspect-[3/2] w-full rounded-lg object-cover"
            />
          </figure>
        )}
      </div>
    </section>
  );
}
